<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="plan-review-agreement-hk-modal-title"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head01">
      <h1
        id="plan-review-agreement-hk-modal-title"
        class="p-modal-head01__title"
        [innerHTML]="'heading.agreement' | staticMsg"
      ></h1>
      <button id="close-hk-modal" class="p-modal-head01__close js-modal-close" (click)="clickClose()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <div class="p-modal-body01">
      <div class="hk-agreement-text">
        <p>
          <em class="c-text-m c-text-m--bold" [innerHTML]="'rule.purposeUsingPersonalInformation' | staticMsg"></em>
        </p>
        <ul class="hk-agreement-text__rule-list">
          <!-- ANAおよびANAグループ会社による航空運送サービス・商品、旅行サービス・旅行商品のために個人情報を利用する旨 -->
          <li [innerHTML]="'rule.purposeUsingContent.serviceAndProduct' | staticMsg"></li>
          <!-- ANAマイレージプログラム、およびANAカード香港に関するプロモーションのために個人情報を利用する旨 -->
          <li [innerHTML]="'rule.purposeUsingContent.mileageProgramAndPromotion' | staticMsg"></li>
          <!-- 各種イベント・キャンペーン運営、管理および各種情報の提供のために個人情報を利用する旨 -->
          <li [innerHTML]="'rule.purposeUsingContent.eventCampaignManagementAndInformationProvision' | staticMsg"></li>
        </ul>
      </div>
      <div class="p-modal-body01__checkbox">
        <asw-checkbox
          id="plan-review-agreement-hk-modal-chkbox"
          [label]="'message.agreementRules.hk' | staticMsg"
          [formControl]="agreementFC"
          required
        ></asw-checkbox>
      </div>
    </div>
  </div>

  <div #modalFooter [class]="lmodalFooterClass">
    <div class="p-modal-foot02">
      <div></div>
      <asw-button
        id="plan-review-agreement-hk-modal-agreement-btn"
        [disabled]="!agreementFC.value"
        (click$)="clickContinue()"
        [label]="'label.continue2' | staticMsg"
      ></asw-button>
    </div>
  </div>
</div>
